// Generated by `pnpm gen:svg` from src/assets/svg — do not edit.
import type { SVGProps } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  ref?: Ref<SVGSVGElement>;
}
const SvgBow = ({
  title,
  titleId,
  ref,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    id="Vrstva_1"
    data-name="Vrstva 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="312 156 220 220"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <defs>
      <style>{`
.bw-1,
.bw-2,
.bw-3,
.bw-4,
.bw-5,
.bw-6,
.bw-7 {
  stroke-miterlimit: 10;
}

.bw-1,
.bw-2,
.bw-7 {
  stroke-width: 0.75px;
}

.bw-1,
.bw-4,
.bw-8 {
  fill: var(--mascot-accent, #ff49a4);
}

.bw-1,
.bw-7 {
  stroke: #484747;
}

.bw-2,
.bw-4,
.bw-5,
.bw-6 {
  stroke: #000;
}

.bw-2,
.bw-7 {
  fill: none;
}

.bw-3 {
  stroke: #fff;
  stroke-width: 0.25px;
}

.bw-9,
.bw-6 {
  fill: #fff;
}

.bw-10 {
  fill: #484747;
}

.bw-11 {
  fill: #f39ee5;
}

.bw-4,
.bw-5,
.bw-6 {
  stroke-width: 0.5px;
}

.bw-8 {
  opacity: 0.4;
}
`}</style>
    </defs>
    <path
      className="bw-9"
      d="M527.58,270.55c0,35.48-17.52,66.86-44.39,85.97-.73.52-1.48,1.04-2.23,1.54-.05.03-.09.06-.14.09-.52.35-1.04.69-1.56,1.03-.02.01-.04.03-.06.04-.45.3-.9.58-1.36.86-13.76,8.58-29.64,14.08-46.68,15.51-2.4.21-4.82.34-7.27.37-.75.01-1.51.02-2.27.02-.56,0-1.13,0-1.69-.02-.74-.02-1.47-.04-2.21-.08-18.95-.77-36.6-6.56-51.68-16.06-.52-.33-1.03-.67-1.54-1-.04-.02-.09-.05-.13-.08-.01,0-.01-.01-.02-.01-.18-.13-.37-.25-.56-.38-.06-.03-.12-.08-.18-.12-28.26-18.9-46.88-51.12-46.88-87.68,0-58.13,47.06-105.29,105.16-105.43h.26c58.23,0,105.43,47.21,105.43,105.43Z"
    />
    <path
      className="bw-8"
      d="M527.05,270.55c0,35.48-17.52,66.86-44.39,85.97-.73.52-1.48,1.04-2.23,1.54-.05.03-.09.06-.14.09-.35.23-.69.46-1.04.69-.17.11-.35.23-.52.34-.47.31-.94.61-1.42.9-13.76,8.58-29.64,14.08-46.68,15.51-2.23.19-4.47.32-6.74.37-.75.01-1.51.02-2.27.02-.56,0-1.13,0-1.69-.02-.92,0-1.83-.04-2.74-.08-18.95-.77-36.6-6.56-51.68-16.06-.52-.33-1.03-.67-1.54-1-.04-.02-.09-.05-.13-.08h0s-.01-.01-.01-.01c-.24-.17-.5-.32-.74-.5-28.26-18.9-46.88-51.12-46.88-87.68,0-58.22,47.2-105.43,105.42-105.43h.27c58.11.15,105.16,47.3,105.16,105.43Z"
    />
    <path d="M497.8,320.72c.59-1.89-6.78-11.1-11.89-17.34-5.11-6.22-10.58-13.07-16.12-18.42-2.27-2.2-5.56-5.2-8.64-7.95-.68-.63-1.34-1.23-1.98-1.8-2.14-1.89-4-3.54-5.16-4.55-.77-.68-1.22-1.08-1.22-1.08,0,0-1.41,12.4-.71,17.91.02.17.04.32.07.48.76,5.47,2.95,12.78,7.09,17.75.72.86,1.44,1.64,2.21,2.37.46.43.93.87,1.41,1.28.45.39.97.79,1.51,1.21.7.56,1.42,1.08,2.14,1.62.11.06.22.15.33.24.29.2.56.41.85.61,1.6,1.12,3.23,2.27,4.87,3.59.24.18.47.37.7.56.28.24.53.46.79.67,5.29,4.59,12.76,11.81,14.69,11.13,1.94-.69,8.47-6.39,9.04-8.28Z" />
    <path d="M344.91,320.72c-.59-1.89,6.78-11.1,11.89-17.34,5.11-6.22,10.58-13.07,16.12-18.42,2.27-2.2,5.56-5.2,8.64-7.95.68-.63,1.34-1.23,1.98-1.8,2.14-1.89,4-3.54,5.16-4.55.77-.68,1.22-1.08,1.22-1.08,0,0,1.41,12.4.71,17.91-.02.17-.04.32-.07.48-.76,5.47-2.95,12.78-7.09,17.75-.72.86-1.44,1.64-2.21,2.37-.46.43-.93.87-1.41,1.28-.45.39-.97.79-1.51,1.21-.7.56-1.42,1.08-2.14,1.62-.11.06-.22.15-.33.24-.29.2-.56.41-.85.61-1.6,1.12-3.23,2.27-4.87,3.59-.24.18-.47.37-.7.56-.28.24-.53.46-.79.67-5.29,4.59-12.76,11.81-14.69,11.13-1.94-.69-8.47-6.39-9.04-8.28Z" />
    <path
      className="bw-9"
      d="M479.25,358.84c-.02.13-.03.25-.05.38-.45.3-.9.58-1.36.86-13.76,8.58-29.64,14.08-46.68,15.51-2.4.21-4.82.34-7.27.37-.75.01-1.51.02-2.27.02-.56,0-1.13,0-1.69-.02-.92,0-1.83-.04-2.74-.08-18.95-.77-36.6-6.56-51.68-16.06-.52-.33-1.03-.67-1.54-1-.04-.02-.09-.05-.13-.08h0c-.02-.13-.03-.26-.04-.39-.86-7-.68-14.35.77-21.89,1.24-6.43,2.67-12.74,4.35-18.83.78-2.9,1.62-5.76,2.53-8.55.03-.12.07-.24.11-.36,4.66-14.5,10.75-27.31,18.52-36.73.02-.03.04-.06.07-.09,8.41-10.17,18.8-16.36,31.49-16.41h.15c12.25,0,22.53,5.49,30.95,14.79.35.39.7.79,1.05,1.2,7.82,9.12,13.97,21.61,18.53,36.03,1.19,3.76,2.27,7.65,3.23,11.64,1.37,5.58,2.52,11.38,3.47,17.31,1.23,7.73,1.24,15.24.24,22.38Z"
    />
    <path
      className="bw-5"
      d="M472.01,307.51c-8.98,18.36-28.31,31.06-50.69,31.06s-40.86-12.15-50.07-29.85c9.76-30.33,25.71-53.23,50.24-53.23s40.95,21.74,50.52,52.02Z"
    />
    <path
      className="bw-3"
      d="M456.95,263.41s.07-.01.07-.01c-4.83,15.22-15.21,25.15-18.49,36.06-4.38,14.53-5.7,29.49-6.94,30.84-2.49,2.68-17.41,2.68-20.71,0-1.66-1.35-1.15-15.53-6.11-28.45-5.63-14.63-6.44-16.81-13.67-28.04.01-.03.03-.07.07-.1-4.38-6.67-10.53-19.07-10.53-30.35,0-25.22,18.01-45.67,40.2-45.67s40.2,20.45,40.2,45.67c0,7.2-1.46,14-4.08,20.04Z"
    />
    <g>
      <path
        className="bw-11"
        d="M390.41,258.11c1.3-.53,2.17-1.07,2.69-2.36.52-1.29.27-2.28-.29-3.55-.56-1.28-1.95-2.46-3.14-2.98-1.19-.51-2.01-.69-3.29-.46-1.27.23-3.26,1.49-3.74,2.79-.48,1.31-.27,2.28.3,3.56.56,1.28,1.56,2.34,3.14,2.98,1.57.63,3.04.56,4.34.02Z"
      />
      <path
        className="bw-11"
        d="M450.98,258.06c-1.31-.51-2.19-1.02-2.74-2.3-.55-1.28-.31-2.27.22-3.56.54-1.29,1.9-2.5,3.08-3.04,1.18-.53,2-.73,3.28-.52,1.28.21,3.29,1.42,3.79,2.72.5,1.3.31,2.27-.23,3.56-.54,1.29-1.52,2.37-3.08,3.04-1.56.66-3.03.61-4.33.11Z"
      />
    </g>
    <path
      className="bw-10"
      d="M398.17,206.62c-4.03,3.31-7.81,7.38-10.52,12.13-3.52-1.69-7.16-4.01-7.68-6.46-.96-4.52,1-9.24,3.86-11.17,2.86-1.93,5.41-2.01,8.76-1.15,1.63.41,3.8,3.56,5.58,6.66Z"
    />
    <path
      className="bw-10"
      d="M462.02,212.28c-.52,2.45-4.66,4.78-8.18,6.46-2.7-4.75-5.83-7.96-9.86-11.27,1.77-3.1,3.79-7.11,5.42-7.52,3.35-.86,5.9-.77,8.76,1.15,2.86,1.93,4.82,6.65,3.86,11.17Z"
    />
    <path
      className="bw-6"
      d="M396.08,237.11c.09-5.4-4.24-9.84-9.66-9.93-5.42-.08-9.88,4.22-9.96,9.62-.08,5.4,4.24,9.84,9.66,9.93,5.42.08,9.88-4.22,9.96-9.62Z"
    />
    <g>
      <path d="M385.22,244.81c4.43.69,8.19-3.06,7.51-7.47-.42-2.75-2.67-4.98-5.41-5.41-4.43-.69-8.19,3.06-7.51,7.47.42,2.75,2.67,4.98,5.41,5.41Z" />
      <path d="M385.22,244.81c4.43.69,8.19-3.06,7.51-7.47-.42-2.75-2.67-4.98-5.41-5.41-4.43-.69-8.19,3.06-7.51,7.47.42,2.75,2.67,4.98,5.41,5.41Z" />
    </g>
    <path
      className="bw-6"
      d="M464.77,237.11c.08-5.4-4.24-9.84-9.66-9.93-5.42-.08-9.88,4.22-9.96,9.62-.09,5.4,4.24,9.84,9.66,9.93,5.42.08,9.88-4.22,9.97-9.62Z"
    />
    <path d="M453.91,244.81c4.43.68,8.19-3.06,7.51-7.47-.42-2.75-2.67-4.98-5.42-5.40-4.43-.68-8.19,3.06-7.51,7.47.42,2.75,2.67,4.98,5.42,5.40Z" />
    <path
      className="bw-1"
      d="M460.64,226.95l-10.22-10.61c-.24-.25-.28-.7-.09-1.12l1.94-4.31c.19-.42.55-.69.9-.67l14.67.73c.52.03.75.67.48,1.29l-6.39,14.18c-.28.62-.92.87-1.29.5Z"
    />
    <path
      className="bw-1"
      d="M431.57,213.85l14.72.63c.35.01.71-.26.9-.67l1.94-4.31c.19-.42.15-.87-.09-1.12l-10.27-10.5c-.36-.37-1-.12-1.28.5l-6.39,14.18c-.28.62-.04,1.27.48,1.29Z"
    />
    <rect
      className="bw-1"
      x={446.93}
      y={208.48}
      width={5.63}
      height={7.67}
      rx={2.54}
      ry={2.54}
      transform="translate(126.88 -165.97) rotate(24.25)"
    />
    <line className="bw-7" x1={452.54} y1={212.96} x2={460.35} y2={213.93} />
    <line className="bw-7" x1={451.83} y1={214.52} x2={457.74} y2={219.73} />
    <line className="bw-7" x1={441.56} y1={205.47} x2={447.47} y2={210.67} />
    <line className="bw-7" x1={438.95} y1={211.26} x2={446.76} y2={212.24} />
    <line className="bw-7" x1={452.19} y1={213.73} x2={456.75} y2={215.59} />
    <line className="bw-7" x1={442.42} y1={209.73} x2={446.98} y2={211.59} />
    <path
      className="bw-4"
      d="M376.46,236.95c.08-5.4,4.55-9.71,9.97-9.62,5.42.08,9.74,4.53,9.65,9.93,0,.52-.06,1.03-.14,1.53-2.58-2.08-5.85-3.35-9.43-3.41-3.76-.06-7.2,1.24-9.9,3.41-.11-.6-.16-1.21-.15-1.84Z"
    />
    <path
      className="bw-4"
      d="M464.69,236.95c-.08-5.4-4.55-9.71-9.97-9.62-5.42.08-9.74,4.53-9.65,9.93,0,.52.06,1.03.14,1.53,2.58-2.08,5.85-3.35,9.43-3.41,3.76-.06,7.2,1.24,9.9,3.41.11-.6.16-1.21.15-1.84Z"
    />
    <g>
      <path d="M464.34,238.78c.31-.04.62,0,.93,0,.33.01.66-.02.97-.17.28-.14.51-.36.74-.57s.46-.44.67-.67c.25-.27.49-.56.71-.86.08-.11.02-.28-.09-.34-.13-.08-.26-.02-.34.09-.35.47-.75.9-1.18,1.31-.2.19-.4.39-.64.54s-.5.18-.77.17c-.33,0-.67-.05-1,0-.13.02-.25.1-.25.25,0,.12.12.27.25.25h0Z" />
      <path
        className="bw-2"
        d="M464.34,238.53c.56-.08,1.17.12,1.7-.1.21-.09.39-.23.55-.38.57-.5,1.09-1.05,1.55-1.66"
      />
    </g>
    <g>
      <path d="M447.69,236.94c-.29-.04-.59,0-.88,0-.26.01-.54.01-.78-.11s-.45-.32-.65-.51c-.22-.21-.44-.42-.64-.65-.22-.24-.43-.49-.63-.76-.08-.11-.22-.16-.34-.09-.11.06-.17.23-.09.34.39.52.82,1,1.29,1.44.23.21.46.44.73.6.28.17.6.23.93.23.36,0,.71-.05,1.06,0,.13.02.25-.13.25-.25,0-.15-.12-.23-.25-.25h0Z" />
      <path
        className="bw-2"
        d="M447.69,237.19c-.56-.08-1.17.12-1.7-.1-.21-.09-.39-.23-.55-.38-.57-.5-1.09-1.05-1.55-1.66"
      />
    </g>
    <g>
      <path d="M450.61,235.82c-.29-.04-.59,0-.88,0-.26.01-.54.01-.78-.11s-.45-.32-.65-.51c-.22-.21-.44-.42-.64-.65-.22-.24-.43-.49-.63-.76-.08-.11-.22-.16-.34-.09-.11.06-.17.23-.09.34.39.52.82,1,1.29,1.44.23.21.46.44.73.6.28.17.6.23.93.23.36,0,.71-.05,1.06,0,.13.02.25-.13.25-.25,0-.15-.12-.23-.25-.25h0Z" />
      <path
        className="bw-2"
        d="M450.61,236.07c-.56-.08-1.17.12-1.7-.1-.21-.09-.39-.23-.55-.38-.57-.5-1.09-1.05-1.55-1.66"
      />
    </g>
    <g>
      <path d="M453.86,235.19c-.29-.04-.59,0-.88,0-.26.01-.54.01-.78-.11s-.45-.32-.65-.51c-.22-.21-.44-.42-.64-.65-.22-.24-.43-.49-.63-.76-.08-.11-.22-.16-.34-.09-.11.06-.17.23-.09.34.39.52.82,1,1.29,1.44.23.21.46.44.73.6.28.17.6.23.93.23.36,0,.71-.05,1.06,0,.13.02.25-.13.25-.25,0-.15-.12-.23-.25-.25h0Z" />
      <path
        className="bw-2"
        d="M453.86,235.44c-.56-.08-1.17.12-1.7-.1-.21-.09-.39-.23-.55-.38-.57-.5-1.09-1.05-1.55-1.66"
      />
    </g>
    <g>
      <path d="M456.28,236.39c-.2-.18-.44-.32-.67-.46s-.42-.25-.58-.43c-.06-.07-.13-.18-.18-.29-.06-.14-.1-.3-.14-.44-.08-.32-.15-.65-.21-.98-.06-.36-.1-.73-.12-1.1,0-.13-.11-.25-.25-.25-.13,0-.26.11-.25.25.04.7.15,1.4.32,2.09.08.32.16.65.35.92.17.24.39.41.64.57s.53.3.74.48c.1.09.25.1.35,0,.09-.09.1-.26,0-.35h0Z" />
      <path
        className="bw-2"
        d="M456.1,236.57c-.42-.38-1.04-.55-1.36-1.02-.13-.19-.19-.41-.25-.62-.2-.73-.32-1.48-.36-2.24"
      />
    </g>
    <g>
      <path d="M462,237.32c.31-.04.62,0,.93,0,.33.01.66-.02.97-.17.28-.14.51-.36.74-.57s.46-.44.67-.67c.25-.27.49-.56.71-.86.08-.11.02-.28-.09-.34-.13-.08-.26-.02-.34.09-.35.47-.75.9-1.18,1.31-.2.19-.4.39-.64.54s-.5.18-.77.17c-.33,0-.67-.05-1,0-.13.02-.25.1-.25.25,0,.12.12.27.25.25h0Z" />
      <path
        className="bw-2"
        d="M462,237.07c.56-.08,1.17.12,1.7-.1.21-.09.39-.23.55-.38.57-.5,1.09-1.05,1.55-1.66"
      />
    </g>
    <g>
      <path d="M459.8,236.58c.55-.16,1.19-.05,1.72-.37.28-.16.48-.42.69-.66.21-.26.42-.53.61-.81.21-.3.4-.62.58-.94.06-.12.03-.27-.09-.34s-.28-.03-.34.09c-.3.54-.63,1.06-1.02,1.54-.1.12-.2.24-.3.36-.09.1-.2.22-.29.28-.12.08-.2.12-.33.16-.07.02-.13.04-.2.05-.03,0-.06.01-.1.02,0,0-.05,0-.02,0-.02,0-.04,0-.06,0-.33.04-.67.05-.99.14-.13.04-.21.18-.17.31s.18.21.31.17h0Z" />
      <path
        className="bw-2"
        d="M459.74,236.33c.55-.16,1.17-.05,1.66-.35.19-.12.35-.28.49-.46.49-.58.92-1.2,1.29-1.87"
      />
    </g>
    <g>
      <path d="M456.36,236.03c.54-.21,1.17-.16,1.67-.5.28-.19.47-.47.66-.75s.36-.54.51-.83c.18-.33.35-.66.5-1,.05-.12.04-.27-.09-.34-.11-.06-.29-.04-.34.09-.25.58-.56,1.14-.91,1.67-.09.13-.18.26-.27.39-.03.05-.06.08-.11.14s-.1.11-.15.15c-.01.01-.03.02-.04.03.02-.02-.01,0-.01,0-.03.02-.06.04-.08.05s-.06.03-.09.05c-.01,0-.03.01-.04.02.03-.01,0,0-.02,0-.13.05-.26.08-.4.11-.31.06-.62.1-.91.22-.12.05-.22.17-.17.31.04.12.18.23.31.17h0Z" />
      <path
        className="bw-2"
        d="M456.3,235.79c.53-.21,1.17-.16,1.63-.49.18-.13.32-.31.45-.5.44-.62.81-1.28,1.11-1.98"
      />
    </g>
    <g>
      <path d="M376.96,238.25c-.29-.04-.59,0-.88,0-.26.01-.54.01-.78-.11s-.45-.32-.65-.51c-.22-.21-.44-.42-.64-.65-.22-.24-.43-.49-.63-.76-.08-.11-.22-.16-.34-.09-.11.06-.17.23-.09.34.39.52.82,1,1.29,1.44.23.21.46.44.73.6.28.17.6.23.93.23.36,0,.71-.05,1.06,0,.13.02.25-.13.25-.25,0-.15-.12-.23-.25-.25h0Z" />
      <path
        className="bw-2"
        d="M376.96,238.50c-.56-.08-1.17.12-1.7-.10-.21-.09-.39-.23-.55-.38-.57-.5-1.09-1.05-1.55-1.66"
      />
    </g>
    <g>
      <path d="M393.62,237.42c.31-.04.62,0,.93,0,.33.01.66-.02.97-.17.28-.14.51-.36.74-.57s.46-.44.67-.67c.25-.27.49-.56.71-.86.08-.11.02-.28-.09-.34-.13-.08-.26-.02-.34.09-.35.47-.75.9-1.18,1.31-.2.19-.4.39-.64.54s-.5.18-.77.17c-.33,0-.67-.05-1,0-.13.02-.25.1-.25.25,0,.12.12.27.25.25h0Z" />
      <path
        className="bw-2"
        d="M393.62,237.17c.56-.08,1.17.12,1.7-.10.21-.09.39-.23.55-.38.57-.5,1.09-1.05,1.55-1.66"
      />
    </g>
    <g>
      <path d="M390.7,236.29c.31-.04.62,0,.93,0,.33.01.66-.02.97-.17.28-.14.51-.36.74-.57s.46-.44.67-.67c.25-.27.49-.56.71-.86.08-.11.02-.28-.09-.34-.13-.08-.26-.02-.34.09-.35.47-.75.9-1.18,1.31-.2.19-.4.39-.64.54s-.5.18-.77.17c-.33,0-.67-.05-1,0-.13.02-.25.1-.25.25,0,.12.12.27.25.25h0Z" />
      <path
        className="bw-2"
        d="M390.7,236.04c.56-.08,1.17.12,1.7-.10.21-.09.39-.23.55-.38.57-.5,1.09-1.05,1.55-1.66"
      />
    </g>
    <g>
      <path d="M387.44,235.67c.31-.04.62,0,.93,0,.33.01.66-.02.97-.17.28-.14.51-.36.74-.57s.46-.44.67-.67c.25-.27.49-.56.71-.86.08-.11.02-.28-.09-.34-.13-.08-.26-.02-.34.09-.35.47-.75.9-1.18,1.31-.2.19-.4.39-.64.54s-.5.18-.77.17c-.33,0-.67-.05-1,0-.13.02-.25.1-.25.25,0,.12.12.27.25.25h0Z" />
      <path
        className="bw-2"
        d="M387.44,235.42c.56-.08,1.17.12,1.7-.10.21-.09.39-.23.55-.38.57-.5,1.09-1.05,1.55-1.66"
      />
    </g>
    <g>
      <path d="M385.38,236.72c.18-.16.42-.29.64-.42.23-.14.47-.30.65-.51.21-.26.32-.57.40-.90s.16-.68.22-1.02c.07-.40.11-.81.14-1.21,0-.13-.12-.25-.25-.25-.14,0-.24.11-.25.25-.04.66-.14,1.31-.30,1.95-.07.28-.13.58-.31.81-.13.17-.33.31-.54.43-.26.16-.53.31-.76.51-.10.09-.09.26,0,.35.10.10.25.09.35,0h0Z" />
      <path
        className="bw-2"
        d="M385.20,236.54c.42-.38,1.04-.55,1.36-1.02.13-.19.19-.41.25-.62.20-.73.32-1.48.36-2.24"
      />
    </g>
    <g>
      <path d="M379.30,236.79c-.29-.04-.59,0-.88,0-.26.01-.54.01-.78-.11s-.45-.32-.65-.51c-.22-.21-.44-.42-.64-.65-.22-.24-.43-.49-.63-.76-.08-.11-.22-.16-.34-.09-.11.06-.17.23-.09.34.39.52.82,1,1.29,1.44.23.21.46.44.73.60.28.17.60.23.93.23.36,0,.71-.05,1.06,0,.13.02.25-.13.25-.25,0-.15-.12-.23-.25-.25h0Z" />
      <path
        className="bw-2"
        d="M379.30,237.04c-.56-.08-1.17.12-1.70-.10-.21-.09-.39-.23-.55-.38-.57-.50-1.09-1.05-1.55-1.66"
      />
    </g>
    <g>
      <path d="M381.63,236.07c-.29-.08-.58-.10-.88-.13-.14-.01-.23-.02-.38-.06-.14-.03-.23-.06-.34-.13-.24-.14-.43-.39-.61-.61-.19-.23-.37-.47-.54-.72-.20-.30-.39-.60-.56-.91-.06-.12-.23-.16-.34-.09s-.15.22-.09.34c.32.58.69,1.13,1.10,1.65.20.25.41.51.67.70s.57.26.88.30c.16.02.32.03.48.05.09,0,.13.01.21.03s.17.03.25.06c.13.04.27-.05.31-.17s-.04-.27-.17-.31h0Z" />
      <path
        className="bw-2"
        d="M381.57,236.31c-.55-.16-1.17-.05-1.66-.35-.19-.12-.35-.28-.49-.46-.49-.58-.92-1.20-1.29-1.87"
      />
    </g>
    <g>
      <path d="M385.07,235.52c-.26-.10-.54-.14-.81-.20-.13-.03-.26-.05-.39-.09-.03,0-.06-.02-.09-.03-.02,0-.03-.01-.05-.02.04.01,0,0,0,0-.06-.03-.12-.06-.18-.10,0,0-.04-.03-.03-.02s-.02-.02-.03-.02c-.03-.02-.05-.05-.08-.07-.05-.05-.10-.11-.15-.17,0,0-.03-.04-.01-.01-.01-.01-.02-.03-.03-.04-.02-.03-.04-.06-.06-.09-.04-.06-.09-.13-.13-.19-.18-.27-.35-.54-.50-.82-.17-.31-.33-.64-.48-.97-.05-.12-.24-.16-.34-.09-.12.08-.15.21-.09.34.26.61.58,1.19.95,1.74.18.27.36.55.61.76s.53.30.83.37c.32.07.65.10.95.22.12.05.28-.05.31-.17.03-.14-.04-.26-.17-.31h0Z" />
      <path
        className="bw-2"
        d="M385.01,235.76c-.53-.21-1.17-.16-1.63-.49-.18-.13-.32-.31-.45-.50-.44-.62-.81-1.28-1.11-1.98"
      />
    </g>
  </svg>
);
export { SvgBow };
